<template>
  <div class="project-tasks">
    <p v-if="isNewProject" class="text-muted">{{ $t('saveNewProjectFirst') }}</p>
    <TaskTable v-else :project="project" :isReadOnly="isBlockReadOnly" />
  </div>
</template>

<script>
import TaskTable from '@/components/TaskTable';
import { AccessBlockMixin } from '@/mixins/accessBlock';

/** Number of the unsaved project (ProjectEdit `_new`): the block needs a saved project. */
const NEW_PROJECT_NUMBER = '_new';

/**
 * Block project-tasks ("Aufgaben", see feature page projekt-kommunikation): the task list of the
 * project. `TaskTable` loads and writes through the paths of the block (`projectNumber` in the
 * task actions) and makes itself read-only for viewers (`isReadOnly`).
 *
 * No `BlockFieldset` root: a disabled fieldset would also disable the filters and the paging of
 * the table, which viewers need to read; every write control is covered by `isReadOnly`.
 */
export default {
  name: 'ProjectTasks',
  components: {
    TaskTable,
  },
  mixins: [AccessBlockMixin],
  props: {
    /** The page project; the block data (the task list) is loaded by `TaskTable`. */
    project: { type: Object, required: true },
  },
  computed: {
    isNewProject() {
      return this.project.number === NEW_PROJECT_NUMBER;
    },
  },
};
</script>
